export class Filter {
    filterName: string;
    filterType: string;
    open: boolean;
    filterData: Array<FilterItem>;
}

export class FilterItem {
    itemName: string;
    selected: boolean;
}